import useOnMount from '../hooks/useOnMount'

export default function OnMount({ callback }) {
  useOnMount(callback)
  return null
}
